export const SET_BIKES = "SET_BIKES";
